import createReducer from "../../createReducer";
import { zapierAuthHandlers } from "../handlers";
import { IZapierAuthState } from "../types";

export const zapierAuthUrl: IZapierAuthState = {
    isLoading: false,
    error: null,
    authUrl: null,
    formId: null,
};

export default createReducer(zapierAuthUrl, zapierAuthHandlers);
